<div class="flex justify-between w-full items-center h-auto mb-8">
  <mat-toolbar class="flex justify-between items-center w-full bg-white m-top">
    <div class="basis-1/5 text-left">
      <a routerLink="/home">
        <img
          ngSrc="assets/sondis_logo.png"
          width="100"
          alt="Sondis Logo"
          height="64"
        />
      </a>
    </div>

    <div
      class="hidden lg:flex basis-3/4 flex-nowrap justify-between items-center mx-5"
    >
      <div class="flex w-full">
        <app-search class="w-full"></app-search>
      </div>
      <div>
        <div
          routerLink="/sondisa"
          class="ml-5 p-4 cursor-pointer outline outline-1 outline-sondisBlue rounded-full flex items-center py-2"
        >
          <mat-icon class="text-sondisBlue ml-2 my-2">chat</mat-icon>
          <span class="text-sondisBlue ml-2 my-2">Sondisa</span>
        </div>
      </div>
    </div>

    @if (isAuthenticated) {
      <div class="lg:hidden flex flex-row items-center">
        <div
          routerLink="/sondisa"
          class="p-2 cursor-pointer outline outline-1 outline-sondisBlue rounded-full flex items-center mr-8"
        >
          <mat-icon class="text-sondisBlue ml-2">chat</mat-icon>
          <span class="text-sondisBlue ml-2">Sondisa</span>
        </div>
        <button class="text-gray-600 focus:outline-none" (click)="toggleMenu()">
          <mat-icon>menu</mat-icon>
        </button>
      </div>
    }

    @if (!isAuthenticated) {
      <div class="lg:hidden flex flex-row items-center">
        <div
          routerLink="/sondisa"
          class="p-2 cursor-pointer outline outline-1 outline-sondisBlue rounded-full flex items-center mr-2"
        >
          <mat-icon class="text-sondisBlue ml-2">chat</mat-icon>
          <span class="text-sondisBlue ml-2">Sondisa</span>
        </div>
        <button
          (click)="login()"
          class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded-full mr-2"
          i18n
          data-testid="login-button"
        >
          Anmelden
        </button>
      </div>
    }

    @if (!isAuthenticated) {
      <div class="hidden lg:flex basis-1/5 justify-end">
        <button
          (click)="login()"
          class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded-full mr-2"
          i18n
          data-testid="login-button"
        >
          Anmelden
        </button>
      </div>
    }

    @if (isAuthenticated) {
      <div class="hidden lg:flex basis-1/5 justify-end">
        <button mat-button [matMenuTriggerFor]="menu">
          @if (user && user.profilePicture && user.profilePicture.url) {
            <img
              [src]="user.profilePicture.url"
              class="h-14 w-14 rounded-full border border-black object-cover"
              alt="Profile Picture"
            />
          } @else {
            <div class="w-14 h-14 flex">
              <mat-icon
                class="profile-icon"
                aria-hidden="false"
                aria-label="Profile Icon"
                >account_circle</mat-icon
              >
            </div>
          }
        </button>
        <mat-menu #menu="matMenu">
          <a routerLink="./profile">
            <button mat-menu-item i18n>Profil</button>
          </a>
          @if (hasCompanyRole || hasAdminRole) {
            <a routerLink="./company">
              <button mat-menu-item i18n>Angebote</button>
            </a>
          }
          @if (hasAdminRole) {
            <a routerLink="./company-management" i18n>
              <button mat-menu-item>Firmen</button>
            </a>
          }
          @if (hasAdminRole) {
            <a routerLink="./admin">
              <button mat-menu-item i18n>Administration</button>
            </a>
          }
          @if (hasAdvisoryBoardRole) {
            <a
              routerLink="./advisory-board"
              data-testid="advisory-board-link-button"
            >
              <button mat-menu-item i18n>Fachbeirat</button>
            </a>
          }
          <button mat-menu-item (click)="logout()" i18n>
            <mat-icon>logout</mat-icon>
            <span>Abmelden</span>
          </button>
        </mat-menu>
      </div>
    }
  </mat-toolbar>

  @if (showMobileSearchBar) {
    <div class="fixed bottom-0 w-full p-2 bg-white shadow-lg lg:hidden z-50">
      <app-search class="w-full"></app-search>
    </div>
  }

  @if (isMenuOpen) {
    <div
      class="fixed inset-0 z-50 bg-white flex flex-col items-end p-4 lg:hidden"
    >
      @if (isAuthenticated) {
        <button class="text-black text-2xl mb-4" (click)="toggleMenu()">
          ✖
        </button>
        <div class="flex flex-col items-end text-right w-full">
          <a
            routerLink="./profile"
            class="text-black text-xl mb-4"
            (click)="toggleMenu()"
            i18n
            >Profil</a
          >
          @if (hasCompanyRole) {
            <a
              routerLink="./company"
              class="text-black text-xl mb-4"
              (click)="toggleMenu()"
              i18n
              >Angebote</a
            >
          }
          @if (hasAdminRole) {
            <a
              routerLink="./company-management"
              class="text-black text-xl mb-4"
              (click)="toggleMenu()"
              i18n
              >Firmen</a
            >
          }
          @if (hasAdminRole) {
            <a
              routerLink="./admin"
              class="text-black text-xl mb-4"
              (click)="toggleMenu()"
              i18n
              >Administration</a
            >
          }
          @if (hasAdvisoryBoardRole) {
            <a
              routerLink="./advisory-board"
              class="text-black text-xl mb-4"
              (click)="toggleMenu()"
              i18n
            >
              Fachbeirat
            </a>
          }
          <button
            (click)="logout(); toggleMenu()"
            class="text-black text-xl flex flex-row items-center"
            i18n
          >
            <mat-icon>logout</mat-icon>
            <span>Abmelden</span>
          </button>
        </div>
      }
      @if (!isAuthenticated) {
        <button class="text-black text-2xl mb-4" (click)="toggleMenu()">
          ✖
        </button>
        <div class="flex flex-row items-end text-right w-full">
          <button
            (click)="login()"
            class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded-full mr-2"
            i18n
            data-testid="login-button"
          >
            Anmelden
          </button>
        </div>
      }
    </div>
  }
</div>
